<template>
  <esg-base-dashboard-card id="relatedCorpChartCard" title="협력사 월별 배출량 (tCO2e)">
    <template #actions>
      <b-col cols = '12'>
        <b-row align-h = 'end'>
              <b-form-group 
                        content-cols="auto"
                        class="mb-0 mr-3 text-nowrap">
            <b-input-group size="sm">
              <b-form-select v-model="selectedYear" size="sm">
                <option disabled="true" :value="'all'">기간</option>
                <option :value="2023">2023</option>
                <option :value="2022">2022</option>
                <option :value="2021">2021</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-row>
      </b-col>
    </template>
    <apex-chart ref="chart"
                 height="150"
                 type="bar"
                 :options="chartOptions"
                 :series="series"/>
  </esg-base-dashboard-card>
</template>
<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";

export default {
  components: { EsgBaseDashboardCard },
  data() {
    return {
      selectedYear : 2023,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top', // top, center, bottom
            },
            columnWidth : '30%'
          }
        },
        dataLabels: {
          enabled: false,
          formatter: function (val,options) {             
            let percentage = Math.round(val / options.config.series[0].data.reduce((sum, current) => sum + current, 0) * 100,0)
            return val.toLocaleString('ko-kr') ;
          },
          offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ["#304758"]
          }
        },
        xaxis: {
          show: false,
          categories: ["3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월", "1월", "2월"],
          axisBorder: {
            show: true
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            show: false,
          },
          tooltip: {
            enabled: false,
          }
        },
        yaxis: {
          show: false,
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false,
          },
          crosshairs: {
            show: false,
          },
          tooltip: {
            enabled: false
          },
          labels: {
            show: false,
            formatter: function (val) {
              return val.toLocaleString('ko-kr') + " tCO2e";
            }
          }
        },
        responsive: [
          {
            breakpoint: 1250,
            options: {
              chart: { height: 300, width: 650 },
            }
          },
          {
            breakpoint: 992,
            options: {
              chart: { height: 300, width: 700 },
            }
          },
          {
            breakpoint: 768,
            options: {
              chart: { height: 300, width: 450 },
            }
          },
          {
            breakpoint: 576,
            options: {
              chart: { height: 300, width: 350 },
            }
          },
        ],
        grid: { show: false },
      },
    }
  },
  created() {
    this.series = [{
      name: '배출량 ',
      data: [12, 18, 34, 12, 26, 56, 5, 8, 45, 25, 4, 4]
    }]

  },
}
</script>
<style>
#relatedCorpChartCard .card-body{
  padding: 0px;
}
</style>
